// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BulkFollowSuggestion-cls1__a599eac1ac9750370692{/*!*/}.BulkFollowSuggestion-cls2___b3b862030e2b9dacf64{flex:1 1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "BulkFollowSuggestion-cls1__a599eac1ac9750370692",
	"cls2": "BulkFollowSuggestion-cls2___b3b862030e2b9dacf64 BulkFollowSuggestion-cls1__a599eac1ac9750370692"
};
export default ___CSS_LOADER_EXPORT___;
